<template>
  <div class="prefooter-section" data-name="Prefooter">
    <div class="prefooter-container">
      <div class="link-groups-grid">
        <div v-for="(group, index) in linkGroups" :key="index" class="link-group">
          <div class="link-group-header">
            <p class="link-group-title">
              {{ group.title }}
            </p>
            <button
              @click="toggleExpand(index)"
              class="expand-button"
              :aria-expanded="isExpanded(index)"
              :aria-label="`${isExpanded(index) ? 'Contraer' : 'Expandir'} ${group.title}`"
            >
              <span v-if="isExpanded(index)" class="text-xl">-</span>
              <span v-else class="text-xl">+</span>
            </button>
          </div>
          <div class="links-wrapper" :class="{ 'expanded': isExpanded(index) }">
            <p v-for="(link, linkIndex) in group.links" :key="linkIndex" class="link-item">
              <a :href="link.url" class="link-anchor">
                {{ link.text }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const linkGroups = [
  {
    title: "CON AVAL DE COCHE",
    links: [
      { text: "Con Aval de coche", url: "https://ibancar.com/credito-con-aval" },
      { text: "Dinero rápido", url: "https://ibancar.com/dinero-rapido-con-tu-coche" },
      { text: "Coche más de 10 años", url: "https://ibancar.com/prestamos-con-aval-del-coche-de-mas-de-10-anos" },
      { text: "Préstamo rápido", url: "https://ibancar.com/prestamo-rapido" },
      { text: "Préstamos a plazos rápidos online", url: "https://ibancar.com/prestamo-plazos-rapidos" },
      { text: "Mini Préstamos", url: "https://ibancar.com/miniprestamos" },
      { text: "Préstamo personal", url: "https://ibancar.com/prestamo-personal" },
      { text: "Crédito Coche", url: "https://ibancar.com/credito-coche" },
      { text: "MINICREDITOS", url: "https://ibancar.com/minicreditos" }
    ]
  },
  {
    title: "POR UBICACIÓN",
    links: [
      { text: "Préstamos por tu coche Valencia", url: "https://ibancar.com/prestamos-aval-coche-valencia" },
      { text: "Prestamos por tu coche Alicante", url: "https://ibancar.com/prestamos-por-tu-coche-alicante" },
      { text: "Créditos por tu coche Las Palmas", url: "https://ibancar.com/credito-aval-coche-las-palmas" },
      { text: "Créditos por tu coche Barcelona", url: "https://ibancar.com/credito-por-tu-coche-en-barcelona" },
      { text: "Créditos por tu coche Madrid", url: "https://ibancar.com/credito-por-tu-coche-en-madrid" },
      { text: "Créditos por tu coche Sevilla", url: "https://ibancar.com/credito-por-tu-coche-en-sevilla" },
      { text: "Créditos por tu coche Valencia", url: "https://ibancar.com/credito-por-tu-coche-en-valencia" },
      { text: "Dinero rápido Valencia", url: "https://ibancar.com/dinero-rapido-valencia" }
    ]
  },
  {
    title: "CON ASNEF",
    links: [
      { text: "URGENTES", url: "https://ibancar.com/prestamos-urgentes-asnef" },
      { text: "Con ASNEF y Nómina", url: "https://ibancar.com/prestamos-con-asnef-y-nomina-rapidos" },
      { text: "Sin intermediarios", url: "https://ibancar.com/prestamos-asnef-sin-intermediarios" },
      { text: "En el acto", url: "https://ibancar.com/prestamos-asnef-en-el-acto" },
      { text: "Particulares", url: "https://ibancar.com/prestamos-particulares-asnef" },
      { text: "Micro préstamos con ASNEF", url: "https://ibancar.com/micro-prestamos-asnef" },
      { text: "Dinero al instante", url: "https://ibancar.com/dinero-instante-asnef" },
      { text: "1000 euros ASNEF", url: "https://ibancar.com/prestamo-1000-euros-asnef" },
      { text: "Aval Coche", url: "https://ibancar.com/credito-aval-coche-con-asnef" }
    ]
  },
  {
    title: "POR CANTIDAD",
    links: [
      { text: "Consigue 5000 euros", url: "https://ibancar.com/prestamos-5000-euros" },
      { text: "Consigue 2000 euros", url: "https://ibancar.com/prestamo-rapido-2000-euros" },
      { text: "Consigue 3000 euros", url: "https://ibancar.com/prestamo-rapido-3000-euros" },
      { text: "Consigue 6000 euros", url: "https://ibancar.com/prestamo-rapido-6000-euros" },
      { text: "Consigue 1500 euros", url: "https://ibancar.com/prestamo-rapido-1500-euros" },
      { text: "Consigue 8000 euros", url: "https://ibancar.com/credito-8000-euros" }
    ]
  },
  {
    title: "PRÉSTAMOS PARA",
    links: [
      { text: "Boda", url: "https://ibancar.com/prestamos-bodas" },
      { text: "Negocio", url: "https://ibancar.com/prestamo-iniciar-negocio" },
      { text: "Reformar tu vivienda", url: "https://ibancar.com/prestamo-reformar-vivienda" },
      { text: "Reunificar deudas", url: "https://ibancar.com/prestamo-reunificar-deudas" },
      { text: "Para terreno", url: "https://ibancar.com/prestamo-terreno" },
      { text: "Para entrada piso", url: "https://ibancar.com/prestamo-piso" },
      { text: "Para jubilados", url: "https://ibancar.com/prestamo-jubilados" },
      { text: "Para placas solares", url: "https://ibancar.com/prestamo-placas-solares" },
      { text: "Para autónomos", url: "https://ibancar.com/prestamo-autonomos" }
    ]
  }
];

const expandedState = ref({});

const toggleExpand = (index) => {
  expandedState.value[index] = !expandedState.value[index];
};

const isExpanded = (index) => {
  return !!expandedState.value[index];
};
</script>

<style scoped>
.prefooter-section {
  width: 100%;
  background-color: #b3dcff;
  padding: 35px 1.5rem;
}

.prefooter-container {
  max-width: 80rem;
  margin-inline: auto;
}

.link-groups-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 2rem;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  color: #004680;
}

.link-group {
  line-height: 25px;
  white-space: pre;
}

.link-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.link-group-title {
  margin-bottom: 0;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
}

.expand-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  color: #004680;
  background-color: transparent;
  border: none;
  border-radius: 0.25rem;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  padding: 0;
}

.expand-button:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.expand-button .text-xl {
  font-size: 1.25rem;
}

.links-wrapper {
  display: none;
}

.links-wrapper.expanded {
  display: block;
}

.link-item {
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  margin-bottom: 0;
  font-size: 13px;
}

.link-anchor {
  color: #004680;
  transition: color 200ms;
  text-decoration: none;
}

.link-anchor:hover {
  text-decoration: underline;
}

/* estilos responsive */
@media (min-width: 768px) {
  .link-groups-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .link-group-header {
    display: block;
  }
  .expand-button {
    display: none;
  }
  .links-wrapper {
    display: block;
  }
}

@media (min-width: 1024px) {
  .link-groups-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1280px) {
  .link-groups-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
</style>